import React from "react"

export const CurvedLinesIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="403"
      height="152"
      fill="none"
      viewBox="0 0 403 152"
      className={className}
      {...rest}
    >
      <path
        fill="url(#paint0_linear_2504_33892)"
        fillOpacity="0.5"
        d="M28.712 102.677C15.032 110.391 9.419 135.14 1 150.89h402V41.928c-3.508 0-16.838-14.946-29.115-8.196-12.278 6.75-15.786 85.819-36.833 88.712-21.047 2.893-30.869-77.623-56.476-74.73-25.607 2.892-19.293 77.375-43.147 80.033-23.853 2.659-43.848-131.14-64.895-125.836-21.047 5.303-21.749 65.088-33.675 74.248-11.927 9.16-22.801-13.017-35.079-8.678-12.277 4.34-17.188 52.07-29.817 53.999-12.628 1.928-31.57-26.517-45.251-18.803z"
      ></path>
      <path
        stroke="url(#paint1_linear_2504_33892)"
        strokeWidth="2"
        d="M1 150.89c8.419-15.75 14.031-40.499 27.712-48.213 13.68-7.715 32.623 20.731 45.251 18.803 12.629-1.929 17.54-49.66 29.817-53.999 12.278-4.34 23.152 17.839 35.079 8.678C150.785 67 151.487 7.214 172.534 1.911c21.047-5.303 41.042 128.495 64.895 125.836 23.854-2.658 17.54-77.14 43.147-80.034 25.607-2.892 35.429 77.624 56.476 74.731 21.047-2.893 24.555-81.963 36.833-88.712 12.277-6.75 25.607 8.196 29.115 8.196"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_2504_33892"
          x1="202"
          x2="202"
          y1="1.757"
          y2="172.057"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4E2FF"></stop>
          <stop offset="1" stopColor="#ECF6FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_2504_33892"
          x1="201.899"
          x2="201.899"
          y1="150.877"
          y2="1.728"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5080FD"></stop>
          <stop offset="0.25" stopColor="#5080FD"></stop>
          <stop offset="0.313" stopColor="#5080FD"></stop>
          <stop offset="0.344" stopColor="#5080FD"></stop>
          <stop offset="0.352" stopColor="#5081FD"></stop>
          <stop offset="0.359" stopColor="#5181FD"></stop>
          <stop offset="0.367" stopColor="#5182FD"></stop>
          <stop offset="0.375" stopColor="#5182FD"></stop>
          <stop offset="0.383" stopColor="#5183FD"></stop>
          <stop offset="0.391" stopColor="#5184FD"></stop>
          <stop offset="0.398" stopColor="#5284FD"></stop>
          <stop offset="0.406" stopColor="#5285FD"></stop>
          <stop offset="0.414" stopColor="#5285FD"></stop>
          <stop offset="0.422" stopColor="#5286FD"></stop>
          <stop offset="0.43" stopColor="#5286FD"></stop>
          <stop offset="0.438" stopColor="#5387FD"></stop>
          <stop offset="0.445" stopColor="#5387FD"></stop>
          <stop offset="0.453" stopColor="#5388FD"></stop>
          <stop offset="0.461" stopColor="#5389FD"></stop>
          <stop offset="0.469" stopColor="#5489FD"></stop>
          <stop offset="0.477" stopColor="#548AFD"></stop>
          <stop offset="0.484" stopColor="#548AFD"></stop>
          <stop offset="0.492" stopColor="#548BFD"></stop>
          <stop offset="0.5" stopColor="#548BFD"></stop>
          <stop offset="0.508" stopColor="#558CFD"></stop>
          <stop offset="0.516" stopColor="#558CFD"></stop>
          <stop offset="0.523" stopColor="#558DFD"></stop>
          <stop offset="0.531" stopColor="#558EFD"></stop>
          <stop offset="0.539" stopColor="#558EFD"></stop>
          <stop offset="0.547" stopColor="#568FFD"></stop>
          <stop offset="0.555" stopColor="#568FFD"></stop>
          <stop offset="0.563" stopColor="#5690FD"></stop>
          <stop offset="0.57" stopColor="#5690FD"></stop>
          <stop offset="0.578" stopColor="#5791FD"></stop>
          <stop offset="0.586" stopColor="#5791FD"></stop>
          <stop offset="0.594" stopColor="#5792FD"></stop>
          <stop offset="0.602" stopColor="#5792FD"></stop>
          <stop offset="0.609" stopColor="#5793FD"></stop>
          <stop offset="0.617" stopColor="#5894FD"></stop>
          <stop offset="0.625" stopColor="#5894FD"></stop>
          <stop offset="0.633" stopColor="#5895FD"></stop>
          <stop offset="0.641" stopColor="#5895FD"></stop>
          <stop offset="0.648" stopColor="#5896FD"></stop>
          <stop offset="0.656" stopColor="#5996FC"></stop>
          <stop offset="0.664" stopColor="#5997FC"></stop>
          <stop offset="0.672" stopColor="#5997FC"></stop>
          <stop offset="0.68" stopColor="#5998FC"></stop>
          <stop offset="0.688" stopColor="#5A99FC"></stop>
          <stop offset="0.695" stopColor="#5A99FC"></stop>
          <stop offset="0.703" stopColor="#5A9AFC"></stop>
          <stop offset="0.711" stopColor="#5A9AFC"></stop>
          <stop offset="0.719" stopColor="#5A9BFC"></stop>
          <stop offset="0.727" stopColor="#5B9BFC"></stop>
          <stop offset="0.734" stopColor="#5B9CFC"></stop>
          <stop offset="0.742" stopColor="#5B9CFC"></stop>
          <stop offset="0.75" stopColor="#5B9DFC"></stop>
          <stop offset="0.758" stopColor="#5B9EFC"></stop>
          <stop offset="0.766" stopColor="#5C9EFC"></stop>
          <stop offset="0.773" stopColor="#5C9FFC"></stop>
          <stop offset="0.781" stopColor="#5C9FFC"></stop>
          <stop offset="0.789" stopColor="#5CA0FC"></stop>
          <stop offset="0.797" stopColor="#5DA0FC"></stop>
          <stop offset="0.805" stopColor="#5DA1FC"></stop>
          <stop offset="0.813" stopColor="#5DA1FC"></stop>
          <stop offset="0.82" stopColor="#5DA2FC"></stop>
          <stop offset="0.828" stopColor="#5DA3FC"></stop>
          <stop offset="0.836" stopColor="#5EA3FC"></stop>
          <stop offset="0.844" stopColor="#5EA4FC"></stop>
          <stop offset="0.852" stopColor="#5EA4FC"></stop>
          <stop offset="0.859" stopColor="#5EA5FC"></stop>
          <stop offset="0.867" stopColor="#5EA5FC"></stop>
          <stop offset="0.875" stopColor="#5FA6FC"></stop>
          <stop offset="0.883" stopColor="#5FA6FC"></stop>
          <stop offset="0.891" stopColor="#5FA7FC"></stop>
          <stop offset="0.898" stopColor="#5FA8FC"></stop>
          <stop offset="0.906" stopColor="#60A8FC"></stop>
          <stop offset="0.914" stopColor="#60A9FC"></stop>
          <stop offset="0.922" stopColor="#60A9FC"></stop>
          <stop offset="0.93" stopColor="#60AAFC"></stop>
          <stop offset="0.938" stopColor="#60AAFC"></stop>
          <stop offset="0.945" stopColor="#61ABFC"></stop>
          <stop offset="0.953" stopColor="#61ABFC"></stop>
          <stop offset="0.961" stopColor="#61ACFC"></stop>
          <stop offset="0.969" stopColor="#61ADFC"></stop>
          <stop offset="0.977" stopColor="#61ADFC"></stop>
          <stop offset="0.984" stopColor="#62AEFC"></stop>
          <stop offset="0.992" stopColor="#62AEFC"></stop>
          <stop offset="1" stopColor="#62AFFC"></stop>
        </linearGradient>
      </defs>
    </svg>
  )
}
